<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs :title="$t('changeAccount.irktProfili')" />

      <!-- Loading Indicator -->
      <div v-if="!companyDetails && showDashboard===0" class="text-center py-5">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-2">Məlumatlar yüklənir...</p>
      </div>

      <div
        v-if="showDashboard===0"
        class="row"
      >
        <div
          v-if="companyDetails"
          class="col-xl-12 "
        >
          <div class="row">
            <div class="col-xl-7">
              <div class="card">
                <div class="card-header">
                  <h4 class="mb-0"><i class="fa fa-building-o mr-2"></i>{{ $t('changeAccount.irktProfili') }}</h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3">
                      <input
                        id="fileInput"
                        ref="file"
                        type="file"
                        style="display: none"
                        @change="setPhoto"
                      >

                      <div class="text-center">
                        <img
                          :src="getPhoto(companyDetails.logo,'mediumCropped')"
                          alt=""
                          class="rounded-circle w-100"
                          style="object-fit: cover; object-position: center; max-height: 100%; max-width: 100%;"
                        >
                        <p
                          v-if="!companyDetails.logo"
                          class="text-danger mt-2"
                        >
                          <i class="fa fa-exclamation-circle"></i> {{ $t('companyProfile.logoRequired') }}
                        </p>
                      </div>

                      <div class="mt-3 text-center">
                        <button
                          class="btn btn-primary mr-2"
                          @click="selectPhoto"
                        >
                          <i class="fa fa-upload mr-1"></i>
                        </button>
                        <button
                          v-if="companyDetails.logo"
                          class="btn btn-outline-danger mr-2"
                          @click.prevent="removeProfilePhoto"
                        >
                          <i class="fa fa-trash mr-1"></i>
                        </button>

                        <div
                          v-if="uploadProgress > 0 && uploadProgress < 100"
                          class="progress mt-3"
                        >
                          <div
                            class="progress-bar progress-bar-striped progress-bar-animated"
                            role="progressbar"
                            aria-valuenow="75"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            :style="{width: `${uploadProgress}%`}"
                          >
                            {{ uploadProgress }}%
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-9">
                      <div class="company-info-card">
                        <div class="company-name">
                          <h3>
                            {{ companyDetails.name }}
                            {{ getCompanyFormat(companyDetails.format) }}
                          </h3>
                          <span 
                            v-if="companyDetails.legalForm === 'JURIDICAL_PERSON'"
                            class="badge bg-primary"
                          >
                            {{ $t('companyProfile.hquqiXs') }}
                          </span>
                          <span 
                            v-if="companyDetails.legalForm === 'INDIVIDUAL'"
                            class="badge bg-info"
                          >
                            {{ $t('companyProfile.fizikiXs') }}
                          </span>
                        </div>

                        <div class="company-details mt-4">
                          <div v-if="companyDetails.legalForm!=='PERSONAL'" class="detail-item">
                            <div class="detail-label">
                              <i class="fa fa-id-card-o mr-2"></i>{{ $t('companyProfile.ven') }}
                            </div>
                            <div class="detail-value">
                              {{ companyDetails.taxId || 'N/A' }}
                            </div>
                          </div>
                          <div v-else class="detail-item">
                            <div class="detail-value">
                              {{ $t('companyProfile.frdiXsProfili') }}
                            </div>
                          </div>

                          <div 
                            v-if="companyDetails.legalForm!=='PERSONAL'"
                            class="detail-item mt-3"
                          >
                            <div class="detail-label">
                              <i class="fa fa-map-marker mr-2"></i>{{ $t('companyProfile.nvan') }}
                            </div>
                            <div class="detail-value d-flex justify-content-between align-items-center">
                              <span v-if="companyDetails.address">{{ companyDetails.address }}</span>
                              <a
                                v-else-if="!companyDetails.address"
                                href="#"
                                class="text-primary"
                                @click.prevent="changeCompanyAddress()"
                              >
                                <i class="fa fa-plus-circle mr-1"></i>{{ $t('companyProfile.nvanLavEt') }}
                                <span
                                  v-if="companyDetails.legalForm !== 'PERSONAL'"
                                  class="text-danger ml-1"
                                >*</span>
                              </a>
                              <button 
                                v-if="companyDetails.address"
                                class="btn btn-sm btn-outline-primary"
                                @click.prevent="changeCompanyAddress()"
                              >
                                <i class="fa fa-edit mr-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <!-- Tax Document Section -->
                    <div
                      v-if="companyDetails.countryCode!=='AZ'&& companyDetails.legalForm!=='PERSONAL'"
                      class="col-md-12 mb-4"
                    >
                      <div class="document-section">
                        <h5 class="section-title">
                          <i class="fa fa-file-text-o mr-2"></i>{{ $t('companyProfile.taxDocument') }}
                        </h5>

                        <div v-if="!companyDetails.taxIdDocument" class="empty-document">
                          <p class="text-muted mb-3">{{ $t('companyProfile.noTaxDocument') }}</p>
                          <button
                            class="btn btn-upload"
                            @click="triggerFileInput('taxFile')"
                          >
                            <i class="fa fa-upload mr-2"></i> {{ $t('companyProfile.taxDocumentLavEt') }}
                          </button>
                        </div>

                        <input
                          ref="taxFile"
                          type="file"
                          class="d-none"
                          @change="uploadTaxDocument()"
                        >

                        <div
                          v-if="companyDetails.taxIdDocument"
                          class="document-card"
                        >
                          <a
                            target="_blank"
                            :href="mediaBase + companyDetails.taxIdDocument"
                            class="document-link"
                          >
                            <div class="document-icon">
                              <i class="fa fa-file-text-o fa-2x"></i>
                            </div>
                            <div class="document-name">
                              {{ companyDetails.taxIdDocument.split('/').pop() }}
                            </div>
                          </a>
                          <button 
                            class="delete-button"
                            @click="deleteTaxDocument"
                            title="Delete document"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Contact Information Section -->
                    <div class="col-md-12 mb-4">
                      <div class="contact-section">
                        <h5 class="section-title">
                          <i class="fa fa-address-card-o mr-2"></i>{{ $t('companyProfile.contactInformation') }}
                        </h5>

                        <!-- Official Company Email -->
                        <div class="form-group mb-4">
                          <label class="form-label">
                            <i class="fa fa-envelope mr-2"></i>{{
                              company.legalForm !== 'PERSONAL' ? $t('companyProfile.officialEmail') : $t('companyProfile.officialEmailPersonal')
                            }}
                          </label>
                          <div class="input-group">
                            <input
                              v-model="emailInput"
                              type="email"
                              class="form-control"
                              :disabled="!emailEditMode"
                              placeholder="company@example.com"
                            >
                            <div class="input-group-append">
                              <button
                                v-if="emailEditMode"
                                class="btn btn-success"
                                @click="saveCompanyEmail"
                                title="Save Email"
                              >
                                <i class="fa fa-save mr-1"></i>
                              </button>
                              <button
                                v-else
                                class="btn btn-outline-primary"
                                @click="enableEmailEditMode"
                                title="Edit Email"
                              >
                                <i class="fa fa-edit mr-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Primary Contact's Mobile Number -->
                        <div class="form-group">
                          <label class="form-label">
                            <i class="fa fa-phone mr-2"></i>{{
                              company.legalForm !== 'PERSONAL' ? $t('companyProfile.primaryContactMobile') : $t('companyProfile.primaryContactMobilePersonal')
                            }}
                          </label>
                          <div class="d-flex align-items-center">
                            <div class="flex-grow-1">
                              <VuePhoneNumberInput
                                v-model="phoneNumberInput"
                                :default-country-code="'AZ'"
                                :disabled="!phoneEditMode"
                                @update="onPhoneUpdate"
                              />
                            </div>
                            <div class="ml-2">
                              <button
                                v-if="phoneEditMode"
                                class="btn btn-success"
                                @click="saveCompanyPhone"
                                title="Save Phone"
                              >
                                <i class="fa fa-save mr-1"></i>
                              </button>
                              <button
                                v-else
                                class="btn btn-outline-primary"
                                @click="enablePhoneEditMode"
                                title="Edit Phone"
                              >
                                <i class="fa fa-edit mr-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Verification Section -->
                    <div class="col-md-12">
                      <div class="verification-section">
                        <div class="d-flex align-items-center mb-3">
                          <div class="verification-status mr-3">
                            <i 
                              :class="[
                                'fa fa-2x', 
                                companyDetails.systemVerifiedCompany === 2 ? 'fa-check-circle text-success' : 
                                companyDetails.systemVerifiedCompany === 1 ? 'fa-clock-o text-warning' : 
                                companyDetails.systemVerifiedCompany === 3 ? 'fa-exclamation-circle text-danger' : 
                                'fa-info-circle text-primary'
                              ]"
                            ></i>
                          </div>
                          <div class="verification-info">
                            <p class="mb-0 text-muted">
                              {{ 
                                companyDetails.systemVerifiedCompany === 2 ? $t('companyProfile.verified') : 
                                companyDetails.systemVerifiedCompany === 1 ? $t('companyProfile.waitingForVerification') : 
                                companyDetails.systemVerifiedCompany === 3 ? $t('companyProfile.rejected') : 
                                $t('companyProfile.notVerified')
                              }}
                            </p>
                          </div>
                        </div>

                        <button
                          class="btn btn-lg"
                          :class="buttonClass"
                          :disabled="companyDetails.systemVerifiedCompany === 2 || companyDetails.systemVerifiedCompany === 1"
                          @click="submitVerificationRequest"
                        >
                          <i 
                            :class="[
                              'fa mr-2', 
                              companyDetails.systemVerifiedCompany === 2 ? 'fa-check-circle' : 
                              companyDetails.systemVerifiedCompany === 1 ? 'fa-clock-o' : 
                              companyDetails.systemVerifiedCompany === 3 ? 'fa-refresh' : 
                              'fa-paper-plane'
                            ]"
                          ></i>
                          {{ buttonText }}
                        </button>

                        <div
                          v-if="companyDetails.systemVerifiedCompany === 0 || companyDetails.systemVerifiedCompany === null || companyDetails.systemVerifiedCompany === undefined"
                          class="mt-3 alert alert-info"
                        >
                          <i class="fa fa-info-circle mr-2"></i>
                          {{ $t('companyProfile.profileVerificationInfo') }}
                        </div>

                        <div
                          v-if="companyDetails.systemVerifiedCompany === 3"
                          class="mt-3 alert alert-danger"
                        >
                          <i class="fa fa-exclamation-circle mr-2"></i>
                          {{ companyDetails.rejectReason || $t('companyProfile.defaultRejectReason') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <UserCompanyAdminDetails />
                </div>
              </div>


              <div
                v-if="companyDetails.legalForm!=='PERSONAL'"
                class="mt-5"
              >
                <h3>{{ $t('companyProfile.irktProfillri') }}</h3>

                <div class="card">
                  <div class="card-header">
                    <a
                      v-for="k in Object.keys(profiles)"
                      :key="k"
                      class="btn m-2"
                      :class="[activeProfile===k?'btn-primary':'btn-outline-primary']"
                      aria-current="true"
                      href="#"
                      @click.prevent="activeProfile = k"
                    >
                      {{ getProfileName(k) }}
                    </a>
                  </div>

                  <div v-if="activeProfile !==''">
                    <div class="card-body">
                      <h4>{{ $t('companyProfile.profili', {getProfileName: getProfileName(activeProfile)}) }}</h4>
                      <p>
                        {{ $t('companyProfile.irktinHrMvcudBirBiznesProfiliZrHmBiznesReytinqiVAk') }}
                      </p>

                      <div v-if="activeProfile ==='SUPPLIER'">
                        <span
                          v-for="x in 5"
                          :key="x"
                          class="d-inline-block"
                        >
                          <i
                            v-if="x <= companySupplyRating "
                            class="fa fa-3x fa-star text-warning"
                          />
                          <i
                            v-else
                            class="fa fa-3x fa-star-o text-secondary"
                          />
                        </span>

                        <span class="h2 ml-3 text-warning">{{ companySupplyRating || '0.0' }}</span>
                      </div>
                      <div v-else-if="activeProfile ==='PROCUREMENT'">
                        <span
                          v-for="x in 5"
                          :key="x"
                          class="d-inline-block"
                        >
                          <i
                            v-if="x <= companyProcurementRating"
                            class="fa fa-3x fa-star text-warning"
                          />
                          <i
                            v-else
                            class="fa fa-3x fa-star-o text-secondary"
                          />
                        </span>

                        <span class="h2 ml-3 text-warning">{{ companyProcurementRating || '0.0' }}</span>
                      </div>
                      <div v-else>
                        <span
                          v-for="x in 5"
                          :key="x"
                          class="d-inline-block"
                        >
                          <i class="fa fa-3x fa-star-o text-secondary" />
                        </span>

                        <span class="h2 ml-3 text-warning">0.0</span>
                      </div>
                    </div>
                    <div class="card-body">
                      <CompanyRateStatistics
                        :company-id="company.id"
                        :profile-type="activeProfile"
                      />
                    </div>
                    <hr>
                    <div class="card-body">
                      <div v-if="editProfileIsOpen">
                        <form @submit.prevent="saveProfile">
                          <div class="row">
                            <div class="col-6 mb-3">
                              <label>{{ $t('companyPage.telefon') }}</label>

                              <VuePhoneNumberInput
                                v-model="editingProfile.phone"
                                :default-country-code="'AZ'"
                                :required="true"
                                :no-example="true"
                                @update="numberUpdated($event)"
                              />
                            </div>
                            <div class="col-6 mb-3">
                              <label>E-mail *</label>
                              <input
                                v-model="editingProfile.email"
                                type="email"
                                class="form-control"
                                required
                              >
                            </div>
                            <div class="col-6 mb-3">
                              <label>{{ $t('companyPage.websayt') }}</label>
                              <input
                                v-model="editingProfile.website"
                                type="text"
                                class="form-control"
                              >
                            </div>
                            <div class="col-6 mb-3">
                              <label>{{ $t('companyProfile.linkedin2') }}</label>
                              <input
                                v-model="editingProfile.linkedin"
                                type="text"
                                class="form-control"
                              >
                            </div>
                          </div>

                          <div class="mb-3">
                            <button
                              type="submit"
                              class="btn btn-primary mr-2"
                            >
                              {{ $t('sectorSelectionModal.yaddaSaxla') }}
                            </button>
                            <a
                              class="btn btn-outline-primary  "
                              @click.prevent="editProfileIsOpen = false"
                            >
                              {{ $t('companyProfile.lvEt2') }}
                            </a>
                          </div>
                        </form>
                      </div>
                      <div v-else>
                        <p class="lead">
                          <strong class="font-weight-bold">{{ $t('companyProfile.telefon') }}</strong> <br>
                          <em>{{ companyActiveProfileData.phone || '-' }}</em>
                        </p>
                        <p class="lead">
                          <strong class="font-weight-bold">{{ $t('companyProfile.email') }}</strong> <br>
                          <em>{{ companyActiveProfileData.email || '-' }}</em>
                        </p>
                        <p class="lead">
                          <strong class="font-weight-bold">{{ $t('companyProfile.websayt') }}</strong> <br>
                          <em>{{ companyActiveProfileData.website || '-' }}</em>
                        </p>
                        <p class="lead">
                          <strong class="font-weight-bold">{{ $t('companyProfile.linkedin') }}</strong> <br>
                          <em>{{ companyActiveProfileData.linkedin || '-' }}</em>
                        </p>

                        <p v-if="!hasAdmin || isAdmin">
                          <button
                            class="btn btn-outline-primary"
                            @click.prevent="editProfileIsOpen= true"
                          >
                            {{ $t('companyProfile.mlumatlarDzliEt') }}
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 mt-4">
                  <div class="documents-section">
                    <h4 class="section-title">
                      <i class="fa fa-file-text-o mr-2"></i>{{ $t('companyProfile.companyDocuments') }}
                    </h4>

                    <ul class="nav nav-tabs custom-tabs" role="tablist">
                      <li class="nav-item" role="presentation">
                        <a
                          id="distributor-tab"
                          class="nav-link"
                          :class="{ active: activeTab === 'distributor' }"
                          role="tab"
                          aria-controls="distributor"
                          aria-selected="activeTab === 'distributor'"
                          @click="activeTab = 'distributor'"
                        >
                          <i class="fa fa-file-text-o mr-2"></i> Distribyutorluq sənədləri
                        </a>
                      </li>
                      <li class="nav-item" role="presentation">
                        <a
                          id="certificates-tab"
                          class="nav-link"
                          :class="{ active: activeTab === 'certificates' }"
                          role="tab"
                          aria-controls="certificates"
                          aria-selected="activeTab === 'certificates'"
                          @click="activeTab = 'certificates'"
                        >
                          <i class="fa fa-certificate mr-2"></i> Sertifikat və lisenziyalar
                        </a>
                      </li>
                      <li class="nav-item" role="presentation">
                        <a
                          id="contracts-tab"
                          class="nav-link"
                          :class="{ active: activeTab === 'contracts' }"
                          role="tab"
                          aria-controls="contracts"
                          aria-selected="activeTab === 'contracts'"
                          @click="activeTab = 'contracts'"
                        >
                          <i class="fa fa-handshake-o mr-2"></i> Oxşar işlərlə bağlı müqavilə və referanslar
                        </a>
                      </li>
                    </ul>

                    <div class="tab-content p-4 bg-white border border-top-0 rounded-bottom">
                      <!-- Distributor Documents Tab -->
                      <div
                        id="distributor"
                        class="tab-pane fade"
                        :class="{ show: activeTab === 'distributor', active: activeTab === 'distributor' }"
                        role="tabpanel"
                        aria-labelledby="distributor-tab"
                      >
                        <div v-if="documentsLoading" class="text-center py-4">
                          <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                        <div v-else-if="documents.distributor.length === 0" class="empty-documents">
                          <i class="fa fa-folder-open-o fa-3x mb-3"></i>
                          <p>No documents available.</p>
                        </div>
                        <div v-else class="row">
                          <div
                            v-for="(doc) in documents.distributor"
                            :key="doc"
                            class="col-md-3 mb-3"
                          >
                            <div class="document-card">
                              <a
                                target="_blank"
                                :href="mediaBase + doc"
                                class="document-link"
                              >
                                <div class="document-icon">
                                  <i class="fa fa-file-text-o fa-2x"></i>
                                </div>
                                <div class="document-name">
                                  {{ doc.split('/').pop() }}
                                </div>
                              </a>
                              <button 
                                class="delete-button"
                                @click="deleteDocument('distributor', doc)"
                                title="Delete document"
                              >
                                <i class="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3">
                          <button
                            class="btn btn-upload"
                            @click="triggerFileInput('distributorFile')"
                          >
                            <i class="fa fa-upload mr-2"></i> Upload File
                          </button>
                          <input
                            ref="distributorFile"
                            type="file"
                            class="d-none"
                            @change="uploadDocument('distributor')"
                          >
                        </div>
                        <div v-if="uploadProgress > 0 && uploadProgress < 100" class="upload-progress mt-3">
                          <div class="progress">
                            <div 
                              class="progress-bar progress-bar-striped progress-bar-animated" 
                              role="progressbar" 
                              :style="`width: ${uploadProgress}%`" 
                              :aria-valuenow="uploadProgress" 
                              aria-valuemin="0" 
                              aria-valuemax="100"
                            >
                              {{ uploadProgress }}%
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Certificates Tab -->
                      <div
                        id="certificates"
                        class="tab-pane fade"
                        :class="{ show: activeTab === 'certificates', active: activeTab === 'certificates' }"
                        role="tabpanel"
                        aria-labelledby="certificates-tab"
                      >
                        <div v-if="documentsLoading" class="text-center py-4">
                          <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                        <div v-else-if="documents.certificates.length === 0" class="empty-documents">
                          <i class="fa fa-folder-open-o fa-3x mb-3"></i>
                          <p>No documents available.</p>
                        </div>
                        <div v-else class="row">
                          <div
                            v-for="(doc, index) in documents.certificates"
                            :key="index"
                            class="col-md-3 mb-3"
                          >
                            <div class="document-card">
                              <a
                                target="_blank"
                                :href="mediaBase + doc"
                                class="document-link"
                              >
                                <div class="document-icon">
                                  <i class="fa fa-certificate fa-2x"></i>
                                </div>
                                <div class="document-name">
                                  {{ doc.split('/').pop() }}
                                </div>
                              </a>
                              <button 
                                class="delete-button"
                                @click="deleteDocument('certificates', doc)"
                                title="Delete document"
                              >
                                <i class="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3">
                          <button
                            class="btn btn-upload"
                            @click="triggerFileInput('certificatesFile')"
                          >
                            <i class="fa fa-upload mr-2"></i> Upload File
                          </button>
                          <input
                            ref="certificatesFile"
                            type="file"
                            class="d-none"
                            @change="uploadDocument('certificates')"
                          >
                        </div>
                      </div>

                      <!-- Contracts Tab -->
                      <div
                        id="contracts"
                        class="tab-pane fade"
                        :class="{ show: activeTab === 'contracts', active: activeTab === 'contracts' }"
                        role="tabpanel"
                        aria-labelledby="contracts-tab"
                      >
                        <div v-if="documentsLoading" class="text-center py-4">
                          <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                        <div v-else-if="documents.contracts.length === 0" class="empty-documents">
                          <i class="fa fa-folder-open-o fa-3x mb-3"></i>
                          <p>No documents available.</p>
                        </div>
                        <div v-else class="row">
                          <div
                            v-for="(doc, index) in documents.contracts"
                            :key="index"
                            class="col-md-3 mb-3"
                          >
                            <div class="document-card">
                              <a
                                target="_blank"
                                :href="mediaBase + doc"
                                class="document-link"
                              >
                                <div class="document-icon">
                                  <i class="fa fa-handshake-o fa-2x"></i>
                                </div>
                                <div class="document-name">
                                  {{ doc.split('/').pop() }}
                                </div>
                              </a>
                              <button 
                                class="delete-button"
                                @click="deleteDocument('contracts', doc)"
                                title="Delete document"
                              >
                                <i class="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3">
                          <button
                            class="btn btn-upload"
                            @click="triggerFileInput('contractsFile')"
                          >
                            <i class="fa fa-upload mr-2"></i> Upload File
                          </button>
                          <input
                            ref="contractsFile"
                            type="file"
                            class="d-none"
                            @change="uploadDocument('contracts')"
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-5">
              <div class="card">
                <div
                  v-if="editWorkingSectors"
                  class="card-body"
                >
                  <p class="lead">
                    {{ $t('companyProfile.faliyytSahsiniDyi') }}
                  </p>
                  <form @submit.prevent="saveWorkingSectors">
                    <div
                      class="card"
                      style="background: #dddddd"
                    >
                      <div class="card-body">
                        <SelectedSectorView
                          :sectors="selectedSectors"
                          :parent-id="0"
                        />

                        <div class="mt-3">
                          <a
                            v-b-modal.modal-sector-selection
                            class="btn btn-primary"
                          >
                            {{ $t('companyProfile.faliyytSahsiniSein') }}
                          </a>
                        </div>
                      </div>
                    </div>


                    <div class="mb-3">
                      <button
                        type="submit"
                        class="btn btn-primary mr-2"
                      >
                        {{ $t('companyProfile.dyiikliyiYaddaSaxla') }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-secondary"
                        @click.prevent="editWorkingSectors = false"
                      >
                        {{ $t('companyProfile.lvEt') }}
                      </button>
                    </div>
                  </form>
                </div>
                <div
                  v-else
                  class="card-body"
                >
                  <SelectedSectorView
                    :sectors="sectors"
                    :parent-id="0"
                  />
                  <button
                    v-if="!hasAdmin || isAdmin"
                    class="btn btn-sm mt-2 btn-outline-primary d-flex align-items-center px-2"
                    @click.prevent="editWorkingSectors = true"
                  >
                    <feather
                      type="settings"
                      size="16"
                      class="mr-2"
                    />
                    {{ $t('companyProfile.faliyytSahlriniDyi') }}
                  </button>
                </div>
              </div>

              <div v-if="companyDetails.legalForm!=='PERSONAL'">
                <div class="mb-3">
                  <h3>{{ $t('dashboardCompany.irktIstifadilri') }}</h3>
                </div>

                <UserCompanyAdminDetails />

                <div
                  v-for="(u,i) in users"
                  :key="i"
                  class="card"
                  :class="{'bg-warning': isAdmin && u.status ==='new'}"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-3">
                        <img
                          class="rounded-circle img-fluid"
                          :src="getPhoto(u.user.photo,'mediumCropped')"
                          alt=""
                          style="object-fit: cover; object-position: center;"
                        >
                      </div>
                      <div class="col-7">
                        <h5>{{ u.user.name }} {{ u.user.surname }}</h5>
                        <h6>
                          <strong>{{ getProfileName(u.profileType) }}</strong>
                        </h6>
                        <p class="p-0 m-0">
                          {{ u.position }}
                        </p>
                        <span
                          v-if="u.status==='verified'"
                          class="badge bg-success"
                        >{{ $t('companyProfile.tsdiqlnmi') }}</span>
                        <span
                          v-else
                          class="badge bg-danger"
                        >{{ $t('companyProfile.tsdiqlnmmi') }}</span>
                        <span
                          v-if="adminUser && adminUser.id === u.user.id"
                          class="badge bg-primary ml-2"
                        >{{ $t('companyProfile.idari') }}</span>
                      </div>
                      <div
                        v-if=" isAdmin"
                        class="col-2"
                      >
                        <button
                          v-if="u.status!=='verified'"
                          type="button"
                          class="btn btn-sm btn-success px-3 mb-2"
                          @click="confirmUserProfile(u.id)"
                        >
                          <feather
                            type="check"
                            size="20"
                          />
                        </button>
                        <br>
                        <button
                          v-if="u.user.id !== user.id"
                          type="button"
                          class="btn btn-sm btn-danger  px-3"
                          @click="rejectUserProfile(u.id)"
                        >
                          <feather
                            type="x"
                            size="20"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-7 mt-3">
              <div class="inquiries-card">
                <div class="inquiries-header">
                  <i class="fa fa-comments mr-2"></i> {{ $t('productInquiries.title') }}
                </div>
                <div class="inquiries-body">
                  <div v-if="inquiriesLoading" class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-2">{{ $t('productInquiries.loading') }}</p>
                  </div>
                  <div v-else-if="inquiries.length === 0" class="empty-inquiries">
                    <i class="fa fa-inbox fa-3x mb-3"></i>
                    <p>{{ $t('productInquiries.noInquiries') }}</p>
                  </div>
                  <ul v-else class="inquiries-list">
                    <li
                      v-for="(inquiry, index) in displayedInquiries"
                      :key="index"
                      class="inquiry-item"
                    >
                      <div class="inquiry-content">
                        <div class="inquiry-product">
                          <img
                            :src="mediaBase + inquiry.coverPhotoUrl"
                            class="inquiry-product-image"
                            alt="Product"
                            style="object-fit: contain; object-position: center; max-width: 100%; height: auto;"
                          >
                          <div class="inquiry-product-details">
                            <h5 class="inquiry-product-name">{{ inquiry.productName }}</h5>
                            <p class="inquiry-text">{{ inquiry.inquiryText }}</p>
                            <div class="inquiry-time">
                              <i class="fa fa-clock-o mr-1"></i> {{ inquiry.inquiryTime }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="inquiry-actions">
                        <button
                          class="btn btn-primary"
                          @click="startConversation(inquiry)"
                        >
                          <i class="fa fa-comment mr-1"></i> {{ $t('productInquiries.startConversation') }}
                        </button>
                      </div>
                    </li>
                  </ul>
                  <div v-if="!inquiriesLoading && inquiries.length > 10 && !showAllInquiries" class="text-center mt-3">
                    <button
                      class="btn btn-view-all"
                      @click="showAllInquiries = true"
                    >
                      <i class="fa fa-eye mr-2"></i> {{ $t('productInquiries.showAll') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="row"
      >
        <div class="col-sm-12 p-0">
          <div class="auth-innerright">
            <div class="authentication-box" />
            <div class="card mt-4 p-4">
              <div
                class="alert alert-primary text-center my-4"
                style="padding: 50px 20px;"
              >
                <feather
                  type="clock"
                  size="40"
                />
                <br>
                <span v-if="showDashboard===1">
                  {{
                    $t('dashboardVue.sizinBuIrktQoulmanzNIrktinizinAdminiTrfindnTsdiqln', {
                      adminName: company.adminName,
                      adminSurname: company.adminSurname
                    })
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-sector-selection"
      centered
      :title="$t('companyProfile.faliyytSahsiniSein')"
      scrollable
      class="theme-modal"
      :busy="false"
    >
      <sector_selection_modal
        :parent-sector="null"
        :selected="selectedSectors"
        :max-selection="20"
        @done="($event)=>{selectedSectors = $event; $bvModal.hide('modal-sector-selection') }"
      />

      <template #modal-footer>
        <div class="text-warning">
          {{ $t('companyProfile.siz20FaliyytSahsiSeBilrsiniz') }}
        </div>
      </template>
    </b-modal>
  </div>
  <!-- Container-fluid Ends-->
</template>
<script>
import {mapState} from "vuex";
import {
  changeCompanyDetail,
  changeCompanySectors,
  companyUserAction,
  getCompanyDetails,
  getCompanyProfiles,
  getCompanyUsers,
  removeCompanyLogo,
  saveProfile,
  updateCompanyLogo,
  upload, userAccounts,
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";

import CompanyRateStatistics from "@/pages/scc/company/CompanyRateStatistics.vue";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import UserCompanyAdminDetails from "@/pages/scc/account/UserCompanyAdminDetails.vue";
import SelectedSectorView from "@/components/SelectedSectorsView.vue";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";
import Sector_path from "@/components/sector_path.vue";
import Multiselect from "vue-multiselect";
import {
  addDocument,
  addTaxDocument,
  deleteDocument,
  deleteTaxDocument,
  getCompanyDocuments,
  sendForVerification,
  updateConfirmMail,
  updateContactPhone
} from "@/repositories/ProductDataRepository";
import {getInquiriesForCompany} from "@/repositories/InquiryDataRepository";
import {startConversation} from "@/repositories/ProductConversationDataRepository";

export default {
  components: {
    SelectedSectorView,
    UserCompanyAdminDetails,
    Sector_selection_modal,
    Sector_path,
    CompanyRateStatistics,
    Multiselect,
    VuePhoneNumberInput
  },
  data() {
    return {
      activeTab: 'distributor', // Set default active tab
      documents: {
        distributor: [],
        certificates: [],
        contracts: []
      },
      mediaBase: mediaBase,
      companyDetails: null,
      showDashboard: 0,
      sectors: [],
      users: [],
      documentsLoading: false,
      adminUser: null,
      profiles: {},
      uploadProgress: 0,
      activeProfile: '',
      allSectors: [],
      selectedSectors: [],
      editWorkingSectors: false,
      editProfileIsOpen: false,
      editingProfile: {},
      phoneNumberObject: null,
      companyActiveProfileData: null,
      inquiries: [],
      showAllInquiries: false,
      inquiriesLoading: false,
      emailEditMode: false,
      phoneEditMode: false,
      phoneObject: null,
      phoneNumberInput: '',
      emailInput: ''
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
      hasAdmin: state => state.auth.hasAdmin,
      isAdmin: state => state.auth.isAdmin,
    }),
    buttonText() {
      switch (this.companyDetails.systemVerifiedCompany) {
        case 0:
        case null:
        case undefined:
          return this.$t('companyProfile.sendVerification');
        case 1:
          return this.$t('companyProfile.waitingForVerification');
        case 2:
          return this.$t('companyProfile.verified');
        default:
          return this.$t('companyProfile.resend');
      }
    },
    buttonClass() {
      switch (this.companyDetails.systemVerifiedCompany) {
        case 0:
        case null:
        case undefined:
          return 'btn-success';
        case 1:
          return 'btn-warning';
        case 2:
          return 'btn-secondary'; // Disabled style
        default:
          return 'btn-danger';
      }
    },
    companySupplyRating() {
      if (!this.companyDetails || this.companyDetails.supplyRateCount === null || this.companyDetails.supplyRateCount < 1) {
        return 0;
      } else {
        return (this.companyDetails.supplyRateTotal / this.companyDetails.supplyRateCount).toFixed(1);
      }
    },
    companyProcurementRating() {
      if (!this.companyDetails || this.companyDetails.procurementRateCount === null || this.companyDetails.procurementRateCount < 1) {
        return 0;
      } else {
        return (this.companyDetails.procurementRateTotal / this.companyDetails.procurementRateCount).toFixed(1);
      }
    },
    displayedInquiries() {
      return this.showAllInquiries ? this.inquiries : this.inquiries.slice(0, 10);
    }
  },
  watch: {
    editWorkingSectors(newVal) {
      if (newVal) {
        this.selectedSectors = this.sectors;
        this.phoneNumberObject = null;
      }
    },
    activeProfile(newVal) {
      this.editProfileIsOpen = false;
      this.companyActiveProfileData = this.profiles[newVal]
    },
    editProfileIsOpen(newVal) {
      if (newVal) {
        this.editingProfile = {...(this.profiles[this.activeProfile])};
      } else {
        this.editingProfile = {};
      }
    },
    profiles: {
      handler(newData) {
        if (newData[this.activeProfile]) {
          this.companyActiveProfileData = newData[this.activeProfile]
        }
      },
      deep: true
    },
    companyDetails: {
      handler(newVal) {
        // Only update phoneNumberInput if not in edit mode
        if (newVal && newVal.contactPhone && !this.phoneEditMode) {
          this.phoneNumberInput = newVal.contactPhone;
        }
        // Only update emailInput if not in edit mode
        if (newVal && newVal.confirmEmail && !this.emailEditMode) {
          this.emailInput = newVal.confirmEmail;
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.getCompanyDetails();
    this.getCompanyUsers();
    this.getCompanyProfiles();
    this.getDocuments();
    this.getInquiries();
    this.userAccount();
    this.timer = setInterval(() => {
      this.userAccount();
    }, 5000)
    this.scheduler = setInterval(() => {
      if (this.companyDetails && (this.companyDetails.systemVerifiedCompany === 2 || this.companyDetails.systemVerifiedCompany === 3)) {
        // Stop the scheduler when systemVerifiedCompany is 2 or 3
        clearInterval(this.scheduler);
      } else {
        // Call getCompanyDetails every 3 seconds when systemVerifiedCompany is 0, 1, null, or undefined
        this.getCompanyDetails();
      }
    }, 3000);
  },
  methods: {
    userAccount() {

      userAccounts(this.token).then(data => {

        let ae = data.filter(profile => {
          return profile.company.id === this.company.id && profile.profileType === this.profile;
        });

        if (ae.length > 0 && this.company.adminName) {
          this.showDashboard = (ae[0].status === "verified") ? 0 : 1;
        }
        if (this.showDashboard === 0) {
          clearInterval(this.timer);
        }
      });
    },
    enableEmailEditMode() {
      this.emailEditMode = true;
      // Initialize emailInput with the current email
      this.emailInput = this.companyDetails.confirmEmail || '';
    },
    enablePhoneEditMode() {
      this.phoneEditMode = true;
      // Initialize phoneNumberInput with the current phone number
      this.phoneNumberInput = this.companyDetails.contactPhone || '';
    },
    onPhoneUpdate(data) {
      // Store the formatted phone number in phoneNumberInput
      if (data && data.formattedNumber) {
        this.phoneNumberInput = data.formattedNumber;
      }
    },
    triggerFileInput(refName) {
      this.$refs[refName].click();
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getCompanyDetails() {
      getCompanyDetails(this.token, this.company.id).then(data => {
        if (data.code === 200) {
          this.companyDetails = data.company;
          this.sectors = data.sectors;
          this.selectedSectors = data.sectors;
        } else {
          this.$router.push({name: 'changeAccount'});
        }
      })
    },
    getCompanyUsers() {
      getCompanyUsers(this.token).then(data => {
        if (data.code === 200) {
          this.users = data.users;
          this.adminUser = data.adminUser;
        }
      })
    },
    getCompanyProfiles() {
      getCompanyProfiles(this.token, this.company.id).then(data => {
        if (data.code === 200) {
          data.profiles.forEach(p => {
            this.profiles[p.profileType] = JSON.parse(p.profileData);
          })
          if (this.activeProfile === '' && data.profiles.length > 0) {
            this.activeProfile = data.profiles[0].profileType;
          } else {
            this.companyActiveProfileData = this.profiles[this.activeProfile]
          }
        }
      })
    },
    changeCompanyAddress() {
      this.$swal({
        title: this.$t("zhmtOlmsYnUnvn"),
        input: 'text',
        icon: 'question',
        inputValue: this.companyDetails.address,
      }).then((result) => {
        if (result.value) {
          changeCompanyDetail(this.token, 'address', result.value).then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("unvnUdlrDysdrl"),
                icon: 'success'
              }).then(() => {
                this.getCompanyDetails();
              })

            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          })
        }

      })

    },
    confirmUserProfile(id) {
      this.$swal({
        title: this.$t("prflTsdqEtmkIstdyn"),
        icon: 'question',
      }).then((result) => {

        if (result.value) {
          companyUserAction(this.token, id, 'verify', '').then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("istfdCPrflTsqd"),
                icon: 'success'
              }).then(() => {
                this.getCompanyUsers();
              })
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          })
        }
      })
    },
    rejectUserProfile(id) {
      this.$swal({
        title: this.$t("prflLgvTmkUchn"),
        icon: 'question',
        input: 'textarea'
      }).then((result) => {

        if (result.value) {
          companyUserAction(this.token, id, 'reject', '').then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("istdfcPrflSlnd"),
                icon: 'success'
              }).then(() => {
                this.getCompanyUsers();
              })
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          })
        } else {
          alert(this.$t("sbbDxlEtmkVcbd"));
        }
      })
    },
    saveWorkingSectors() {
      let sectors = this.selectedSectors.map(function (elem) {
        return elem.id;
      }).join(",")

      changeCompanySectors(this.token, sectors).then(data => {
        if (data.code === 200) {
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: this.$t("flyytShlrDyshdrld"),
            icon: 'success'
          }).then(() => {
            this.editWorkingSectors = false;
            this.getCompanyDetails();
          })
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    },
    removeProfilePhoto() {
      if (confirm(this.$t("sklSlmkIstdyndn"))) {
        removeCompanyLogo(this.token).then(data => {
          if (data.code === 200) {
            this.getCompanyDetails();
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      }
    },
    selectPhoto() {
      window.document.getElementById('fileInput').click();
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'profilePhoto', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {

                updateCompanyLogo(this.token, response.data.path).then(data => {
                  if (data.code === 200) {
                    this.getCompanyDetails();
                  } else {
                    this.$swal({
                      title: `Error ${data.code}`,
                      text: `${data.message}`,
                      icon: 'error'
                    })
                  }
                })

              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {

              this.progress = 0;
              this.$swal({
                title: `Error `,
                text: this.$t("request.cldNotUploadFile") + e,
                icon: 'error'
              })
            });
      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("request.photoUploadNotSpprtdBrowser"),
          icon: 'error'
        })
      }
    },
    saveProfile() {
      if (!this.phoneNumberObject || !this.phoneNumberObject.isValid) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("nmrnDzgnDxlDn"),
          icon: 'warning'
        })
      } else {

        let data = {
          phone: this.phoneNumberObject.e164,
          email: this.editingProfile.email,
          website: this.editingProfile.website,
          linkedin: this.editingProfile.linkedin
        };

        saveProfile(this.token, this.companyDetails.id, JSON.stringify(data), this.activeProfile).then(data => {
          if (data.code === 200) {
            this.$swal({
              title: this.$t("generalModal.successTitle"),
              text: this.$t("unvnUdlrDysdrl"),
              icon: 'success'
            }).then(() => {
              this.getCompanyProfiles();
              this.editProfileIsOpen = false;
            });
          } else {

            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      }
    },

    numberUpdated(p) {
      this.phoneNumberObject = p;
    },
    getDocuments() {
      this.documentsLoading = true;

      getCompanyDocuments(this.token, this.company.id)
        .then(data => {
          if (data.code === 200) {
            this.documents.distributor = data.companyDocumentsDto.distributionDocuments || [];
            this.documents.certificates = data.companyDocumentsDto.certificatesAndLicenses || [];
            this.documents.contracts = data.companyDocumentsDto.contractsAndReferencesForSimilarWorks || [];
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: data.message,
              icon: 'error',
            });
          }
        })
        .catch(error => {
          this.$swal({
            title: 'Error',
            text: error.message || 'Failed to load documents',
            icon: 'error',
          });
        })
        .finally(() => {
          this.documentsLoading = false;
        });
    },
    uploadDocument(type) {
      let fileInput;
      if (type === 'distributor') {
        fileInput = this.$refs.distributorFile;
      } else if (type === 'certificates') {
        fileInput = this.$refs.certificatesFile;
      } else if (type === 'contracts') {
        fileInput = this.$refs.contractsFile;
      }

      let currentFile = fileInput.files[0];
      if (!currentFile) return;

      // Reset progress
      this.uploadProgress = 0;

      // Validate file size
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (currentFile.size > maxSize) {
        this.$swal({
          title: 'File too large',
          text: 'Maximum file size is 10MB',
          icon: 'warning',
        });
        return;
      }

      upload(this.token, type, currentFile, (event) => {
        this.uploadProgress = Math.round((100 * event.loaded) / event.total);
      }, true)
        .then(response => {
          if (response.data.code === 200) {
            const url = response.data.path;
            addDocument(this.token, type, url, this.company.id)
              .then(data => {
                if (data.code === 200) {
                  this.documents[type].push(url);
                  this.$swal({
                    title: 'Success',
                    text: 'Document uploaded successfully',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false
                  });
                } else {
                  this.$swal({
                    title: `Error ${data.code}`,
                    text: data.message,
                    icon: 'error',
                  });
                }
              })
              .finally(() => {
                this.uploadProgress = 0;
                fileInput.value = ''; // Reset file input
              });
          } else {
            this.$swal({
              title: `Error ${response.data.code}`,
              text: response.data.message,
              icon: 'error',
            });
            this.uploadProgress = 0;
            fileInput.value = ''; // Reset file input
          }
        })
        .catch(error => {
          this.uploadProgress = 0;
          fileInput.value = ''; // Reset file input
          this.$swal({
            title: 'Error',
            text: this.$t("cldNotUploadFile") + (error.message || error),
            icon: 'error',
          });
        });
    },
    uploadTaxDocument() {
      let fileInput = this.$refs.taxFile;
      let currentFile = fileInput.files[0];
      if (currentFile) {
        // Get the company ID to add it to the filename
        const newFileName = `taxDocument_${this.company.id}.${currentFile.name.split('.').pop()}`; // keeps the original extension
        const renamedFile = new File([currentFile], newFileName, {
          type: currentFile.type,
        });

        // Call the upload function with the renamed file
        upload(this.token, 'taxDocument', renamedFile, (event) => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        }, true)
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {
                const url = response.data.path;
                addTaxDocument(this.token, url, this.company.id).then(data => {
                  if (data.code === 200) {
                    this.getCompanyDetails();
                  } else {
                    this.$swal({
                      title: `Error ${data.code}`,
                      text: `${data.message}`,
                      icon: 'error',
                    });
                  }
                });
              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error',
                });
              }
            })
            .catch(e => {
              this.uploadProgress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("cldNotUploadFile") + e,
                icon: 'error',
              });
            });
      }
    },

    deleteDocument(type, doc) {
      this.$swal({
        title: 'Are you sure?',
        text: 'This document will be permanently deleted',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t('companyProfile.yesDeleteIt'),
        cancelButtonText: this.$t('companyProfile.cancel')
      }).then((result) => {
        if (result.isConfirmed) {
          deleteDocument(this.token, type, doc, this.company.id)
            .then(data => {
              if (data.code === 200) {
                const index = this.documents[type].indexOf(doc);
                if (index > -1) {
                  this.documents[type].splice(index, 1);
                }
                this.$swal({
                  title: 'Deleted!',
                  text: 'Document has been deleted.',
                  icon: 'success',
                  timer: 1500,
                  showConfirmButton: false
                });
              } else {
                this.$swal({
                  title: `Error ${data.code}`,
                  text: data.message,
                  icon: 'error',
                });
              }
            })
            .catch(error => {
              this.$swal({
                title: 'Error',
                text: error.message || 'Failed to delete document',
                icon: 'error',
              });
            });
        }
      });
    },
    deleteTaxDocument() {
      this.$swal({
        title: 'Are you sure?',
        text: 'This tax document will be permanently deleted',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t('companyProfile.yesDeleteIt'),
        cancelButtonText: this.$t('companyProfile.cancel')
      }).then((result) => {
        if (result.isConfirmed) {
          deleteTaxDocument(this.token, this.company.id)
            .then(data => {
              if (data.code === 200) {
                this.$swal({
                  title: 'Deleted!',
                  text: 'Tax document has been deleted.',
                  icon: 'success',
                  timer: 1500,
                  showConfirmButton: false
                });
                this.getCompanyDetails();
              } else {
                this.$swal({
                  title: `Error ${data.code}`,
                  text: data.message,
                  icon: 'error',
                });
              }
            })
            .catch(error => {
              this.$swal({
                title: 'Error',
                text: error.message || 'Failed to delete tax document',
                icon: 'error',
              });
            });
        }
      });
    },
    saveCompanyEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple regex for email validation

      if (!emailRegex.test(this.emailInput)) {
        // Show error message if email is invalid
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("userCompanyAdminDetails.formatErrorMail"), // Localized error message
          icon: 'error'
        });
        return; // Exit function to prevent further execution
      }

      // Show loading indicator
      this.$swal({
        title: this.$t("generalModal.saving"),
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });

      updateConfirmMail(this.token, this.company.id, this.emailInput)
        .then(response => {
          // Update companyDetails.confirmEmail with the new value
          this.companyDetails.confirmEmail = this.emailInput;
          this.emailEditMode = false;
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: this.$t("generalModal.emailUpdateSuccess"),
            icon: 'success',
            timer: 1500,
            showConfirmButton: false
          });
        })
        .catch(error => {
          this.$swal({
            title: this.$t("generalModal.errorTitle"),
            text: error.message || this.$t("generalModal.notSuccess"),
            icon: 'error'
          });
        });
    },
    saveCompanyPhone() {
      // Show loading indicator
      this.$swal({
        title: this.$t("generalModal.saving"),
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });

      // Use phoneNumberInput instead of companyDetails.contactPhone
      updateContactPhone(this.token, this.company.id, this.phoneNumberInput)
        .then(response => {
          // Update companyDetails.contactPhone with the new value
          this.companyDetails.contactPhone = this.phoneNumberInput;
          this.phoneEditMode = false;
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: this.$t("generalModal.phoneUpdateSuccess"),
            icon: 'success',
            timer: 1500,
            showConfirmButton: false
          });
        })
        .catch(error => {
          this.$swal({
            title: this.$t("generalModal.errorTitle"),
            text: error.message || this.$t("generalModal.notSuccess"),
            icon: 'error'
          });
        });
    },
    submitVerificationRequest() {
      // Handle verification request logic here
      const missingFields = [];
      if (this.emailEditMode || this.phoneEditMode) {
        missingFields.push(this.$t("companyProfile.pleaseSave"));
      }
      // Check each required field and push a message to `missingFields` if it's missing
      // Check emailInput when in edit mode, otherwise check companyDetails.confirmEmail
      if (this.emailEditMode) {
        if (!this.emailInput) {
          missingFields.push(this.$t("companyProfile.emailRequired"));
        }
      } else if (!this.companyDetails.confirmEmail) {
        missingFields.push(this.$t("companyProfile.emailRequired"));
      }
      // Check phoneNumberInput when in edit mode, otherwise check companyDetails.contactPhone
      if (this.phoneEditMode) {
        if (!this.phoneNumberInput) {
          missingFields.push(this.$t("companyProfile.phoneRequired"));
        }
      } else if (!this.companyDetails.contactPhone) {
        missingFields.push(this.$t("companyProfile.phoneRequired"));
      }
      if (!this.companyDetails.taxId) {
        missingFields.push(this.$t("companyProfile.taxIdRequired"));
      }
      if (!this.companyDetails.address && this.companyDetails.legalForm !== 'PERSONAL') {
        missingFields.push(this.$t("companyProfile.addressRequired"));
      }
      if (this.companyDetails.countryCode !== 'AZ' && !this.companyDetails.taxIdDocument) {
        missingFields.push(this.$t("companyProfile.taxIdDocumentRequired"));
      }
      if (!this.companyDetails.logo) {
        missingFields.push(this.$t("companyProfile.logoRequired"));
      }

      // If there are missing fields, show them in a Swal alert
      if (missingFields.length > 0) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          html: `<ul>${missingFields.map(field => `<li>${field}</li>`).join('')}</ul>`,
          icon: 'warning'
        });
      } else {
        // Show loading indicator
        this.$swal({
          title: 'Submitting verification request...',
          text: 'Please wait while we process your request',
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });

        sendForVerification(this.token, this.company.id)
          .then(response => {
            this.$swal({
              title: this.$t("generalModal.successTitle"),
              text: this.$t("generalModal.verificationRequestSuccess"),
              icon: 'success'
            }).then(() => {
              window.location.reload();
            });
          })
          .catch(error => {
            this.$swal({
              title: 'Error',
              text: error.message || 'Failed to submit verification request. Please try again later.',
              icon: 'error'
            });
          });
      }
    },
    getInquiries() {
      // Add a loading state variable to the data object if it doesn't exist
      this.inquiriesLoading = true;

      getInquiriesForCompany(this.token)
        .then(data => {
          if (data) {
            this.inquiries = data;
          } else {
            this.inquiries = [];
          }
        })
        .catch(error => {
          this.$swal({
            title: 'Error',
            text: error.message || 'Failed to load inquiries',
            icon: 'error',
          });
          this.inquiries = [];
        })
        .finally(() => {
          this.inquiriesLoading = false;
        });

    },
    startConversation(inquiry) {
      try {
        // Show loading indicator
        this.$swal({
          title: 'Starting conversation...',
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });

        // Call the startConversation function and pass the token and inquiry ID
        startConversation(this.token, inquiry.id)
          .then(data => {
            this.$swal.close();

            if (data.code === 200) {
              // Get the conversation ID from the response
              const conversationId = data.id;

              // Redirect to the conversation page using the conversation ID
              this.$router.push({
                name: 'conversation',
                params: {id: conversationId},
                query: {conversation_type: "product"}
              });
            } else {
              // Handle the error by showing an alert or message
              this.$swal({
                title: `Error ${data.code}`,
                text: data.message,
                icon: 'error'
              });
            }
          })
          .catch(error => {
            this.$swal({
              title: 'Error',
              text: error.message || 'Failed to start conversation',
              icon: 'error'
            });
          });
      } catch (error) {
        // Handle any other errors
        this.$swal({
          title: 'Error',
          text: error.message || 'An unexpected error occurred',
          icon: 'error'
        });
      }
    }
  }
}
</script>
<style scoped>
/* General Styles */
.container {
  max-width: 1800px;
  padding: 0 20px;
}

/* Animation */
.blink {
  animation: blink-animation 1s steps(5, start) infinite;
}

@keyframes blink-animation {
  50% {
    opacity: 0;
  }
}

/* Company Profile Card */
.card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  margin-bottom: 20px;
}

.card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.card-header {
  background-color: #f8f9fa;
  padding: 15px 20px;
  border-bottom: 1px solid #eaeaea;
}

.card-body {
  padding: 20px;
}

/* Profile Image */
.rounded-circle {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.rounded-circle:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Buttons */
.btn {
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-primary {
  background: linear-gradient(135deg, #4a90e2, #2c6ed1);
  border: none;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #2c6ed1, #1a5cbf);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}

.btn-success {
  background: linear-gradient(135deg, #28a745, #218838);
  border: none;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-success:hover {
  background: linear-gradient(135deg, #218838, #1e7e34);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}

.btn-danger {
  background: linear-gradient(135deg, #dc3545, #c82333);
  border: none;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-danger:hover {
  background: linear-gradient(135deg, #c82333, #bd2130);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}

.btn-outline-primary {
  border: 1px solid #4a90e2;
  color: #4a90e2;
  background-color: transparent;
}

.btn-outline-primary:hover {
  background-color: rgba(74, 144, 226, 0.1);
  color: #2c6ed1;
}

.btn-outline-secondary {
  border: 1px solid #6c757d;
  color: #6c757d;
  background-color: transparent;
}

.btn-outline-secondary:hover {
  background-color: rgba(108, 117, 125, 0.1);
  color: #5a6268;
}

/* Form Elements */
.form-control {
  border-radius: 6px;
  border: 1px solid #ddd;
  padding: 10px 15px;
  transition: all 0.2s ease;
}

.form-control:focus {
  border-color: #4a90e2;
  box-shadow: 0 0 0 0.2rem rgba(74, 144, 226, 0.25);
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #555;
}

.input-group {
  display: flex;
  position: relative;
}

.input-group-append {
  display: flex;
  margin-left: 10px;
}

/* Section Styling */
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eaeaea;
}

.document-section, .contact-section, .verification-section {
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.document-section:hover, .contact-section:hover, .verification-section:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.empty-document {
  text-align: center;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px dashed #ddd;
}

.verification-status {
  display: flex;
  align-items: center;
  justify-content: center;
}

.verification-info {
  flex: 1;
}

/* Alert Styling */
.alert {
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  border: none;
}

.alert-info {
  background-color: rgba(0, 123, 255, 0.1);
  color: #0056b3;
}

.alert-danger {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.btn-upload {
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-upload:hover {
  background-color: #2c6ed1;
  transform: translateY(-2px);
}

/* Badges */
.badge {
  padding: 5px 10px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 0.75rem;
}

.bg-success {
  background-color: #28a745 !important;
}

.bg-danger {
  background-color: #dc3545 !important;
}

.bg-primary {
  background-color: #4a90e2 !important;
}

.bg-warning {
  background-color: #ffc107 !important;
}

/* Company Details */
.lead {
  font-size: 1.1rem;
  line-height: 1.6;
}

.font-weight-bold {
  font-weight: 600;
}

.company-info-card {
  padding: 10px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.company-name h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.company-details {
  margin-top: 15px;
}

.detail-item {
  margin-bottom: 15px;
}

.detail-label {
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 5px;
  font-weight: 500;
}

.detail-value {
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

/* Tabs */
.nav-tabs {
  border-bottom: none;
}

.nav-item {
  margin-right: 5px;
}

.nav-link {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  padding: 12px 20px;
  color: #6c757d;
  font-weight: 500;
  transition: all 0.2s ease;
}

.nav-link:hover {
  background-color: #e9ecef;
}

.nav-link.active {
  background-color: white;
  color: #4a90e2;
  border-bottom: 1px solid white;
  font-weight: 600;
}

/* Document Cards */
.document-card {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: relative;
  transition: all 0.3s ease;
  height: 100%;
  margin-bottom: 15px;
}

.document-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.document-link {
  display: block;
  padding: 15px;
  text-decoration: none;
  color: #333;
}

.document-icon {
  text-align: center;
  margin-bottom: 10px;
  color: #4a90e2;
}

.document-name {
  font-size: 14px;
  text-align: center;
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
}

.delete-button {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.2s ease;
  cursor: pointer;
}

.document-card:hover .delete-button {
  opacity: 1;
}

.delete-button:hover {
  background-color: rgba(220, 53, 69, 0.2);
}

/* User Cards */
.user-card {
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  margin-bottom: 15px;
}

.user-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.user-card-body {
  padding: 20px;
}

.user-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.user-details {
  margin-left: 15px;
}

.user-name {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #333;
}

.user-position {
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 10px;
}

.user-actions {
  display: flex;
  gap: 10px;
}

/* Star Rating */
.star-rating {
  display: inline-block;
  margin-right: 10px;
}

.star-rating i {
  color: #ffc107;
  margin-right: 2px;
  transition: all 0.3s ease;
}

.star-rating i:hover {
  transform: scale(1.2);
}

/* Loading Spinner */
.spinner-border {
  width: 3rem;
  height: 3rem;
  color: #4a90e2;
}

/* Empty States */
.empty-state {
  text-align: center;
  padding: 40px 20px;
  background-color: #f8f9fa;
  border-radius: 10px;
  color: #6c757d;
}

.empty-state i {
  font-size: 3rem;
  margin-bottom: 15px;
  color: #6c757d;
}

/* Inquiries */
.inquiry-item {
  border-bottom: 1px solid #eaeaea;
  padding: 15px 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.inquiry-item:last-child {
  border-bottom: none;
}

.inquiry-content {
  flex: 1;
  margin-right: 20px;
}

.inquiry-product {
  display: flex;
  align-items: flex-start;
}

.inquiry-product-image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
  margin-right: 15px;
}

.inquiry-product-details {
  flex: 1;
}

.inquiry-product-name {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #333;
}

.inquiry-text {
  font-size: 14px;
  color: #555;
  margin-bottom: 8px;
  line-height: 1.5;
}

.inquiry-user, .inquiry-time {
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 3px;
}

.inquiry-actions {
  display: flex;
  align-items: center;
}

.inquiry-actions .btn {
  white-space: nowrap;
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

/* Responsive Adjustments */
@media (max-width: 1199px) {
  .inquiry-item {
    flex-direction: column;
  }

  .inquiry-content {
    margin-right: 0;
    margin-bottom: 15px;
  }
}

@media (max-width: 991px) {
  .nav-link {
    padding: 10px 15px;
    font-size: 14px;
  }
}

@media (max-width: 767px) {
  .card, .user-card, .document-card {
    margin-bottom: 15px;
  }

  .inquiry-product {
    flex-direction: column;
  }

  .inquiry-product-image {
    margin-right: 0;
    margin-bottom: 10px;
  }

  .btn {
    width: 100%;
    margin-bottom: 10px;
  }
}

@media (max-width: 575px) {
  .container {
    padding: 0 10px;
  }

  .card-body {
    padding: 15px;
  }
}

/* Fix for canvas and input in review */
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
